import { useEffect, useState } from "react";
import { useParticipants, useRoomContext } from "@livekit/components-react";
import { RoomEvent } from "livekit-client";

const RaisedHandTracker = ({ onCountChange, onParticipantCountChange }) => {
  const participants = useParticipants();
  const room = useRoomContext();
  // eslint-disable-next-line
  const [updater, setUpdater] = useState(0);

  // Force re-render when metadata changes (to show hand icons for remotes)
  useEffect(() => {
    if (!room) return;
    const handleMetadataChange = () => {
      setUpdater((prev) => prev + 1);
    };
    room.on(RoomEvent.ParticipantMetadataChanged, handleMetadataChange);
    return () => {
      room.off(RoomEvent.ParticipantMetadataChanged, handleMetadataChange);
    };
  }, [room]);

  const getRaisedHands = () => {
    return participants.filter((p) => {
      try {
        const md = p.metadata ? JSON.parse(p.metadata) : {};
        return !!md.handRaised;
      } catch (e) {
        return false;
      }
    });
  };

  const count = getRaisedHands().length;
  const participantCount = participants.length;

  useEffect(() => {
    if (onCountChange) {
      onCountChange(count);
    }
  }, [count, onCountChange]);

  useEffect(() => {
    if (onParticipantCountChange) {
      onParticipantCountChange(participantCount);
    }
  }, [participantCount, onParticipantCountChange]);

  return null;
};

export default RaisedHandTracker;
